import axios from 'axios'
import { CATALOGO_ENDPOINT } from '../../endpoints'

export async function postAuto(body) {
  const response = await axios.post(`${CATALOGO_ENDPOINT}/`, body)
  return response
}
